import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { useTranslation as f } from "react-i18next";
import { isArrayWithItems as x } from "../../../helpers/array-helper.js";
import "dayjs";
import { Heading as w } from "../../elements/heading/heading.js";
import { InPageLinks as T } from "../../elements/in-page-links/in-page-links.js";
import i from "./article-block-v2.module.less.js";
import { TopImage as u } from "./components/top-image.js";
import { useAnimateFadeIn as I } from "../../../animation/animation.js";
import { m as j } from "motion/react";
const k = ({
  date: s,
  category: r,
  mobileImage: t,
  desktopImage: m,
  heading: n,
  preamble: l,
  inPageLinks: o,
  body: c,
  sideComponent: d,
  index: p
}) => {
  const { t: h } = f(), N = I({ whileInView: !1, easing: "easeInOut" });
  return /* @__PURE__ */ e("section", { className: i.section, children: /* @__PURE__ */ a(j.article, { ...N, className: ["padded-sides max-width", i.article].join(" "), children: [
    (s || r) && /* @__PURE__ */ a("div", { className: i.metaWrapper, children: [
      s && /* @__PURE__ */ e("span", { className: "eyebrow", children: s }),
      r && /* @__PURE__ */ e("span", { className: "eyebrow", children: r })
    ] }),
    n && /* @__PURE__ */ e(
      w,
      {
        semanticType: p === 0 ? "h1" : "h2",
        visualType: "h1",
        className: [i.heading, "heading-max-width"].join(" "),
        index: p,
        children: n
      }
    ),
    /* @__PURE__ */ a("div", { className: i.contentWrapper, children: [
      /* @__PURE__ */ a("div", { className: `${i.content}`, children: [
        (t || m) && /* @__PURE__ */ e(u, { imageMobile: t, imageDesktop: m }),
        l && /* @__PURE__ */ e("p", { className: `${i.preamble} preamble text-max-width`, children: l }),
        x(o) && /* @__PURE__ */ e(T, { title: h("TABLE_OF_CONTENTS_TITLE"), links: o }),
        c && /* @__PURE__ */ e("div", { className: `${i.body} article text-max-width`, children: c })
      ] }),
      /* @__PURE__ */ e("aside", { className: [i.sideComponents, "text-max-width"].join(" "), children: d && d })
    ] })
  ] }) });
};
export {
  k as default
};
